import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (F90G)
// ============================================================

export interface F90G {
  f90g_01: string;        // 班別代號 (PK, max 4 chars)
  f90g_11: string | null; // 生效開始日期
  f90g_12: string;        // 上班時間（週一~五）
  f90g_13: string;        // 下班時間（週一~五）
  f90g_14: string;        // 上班時間（週六）
  f90g_15: string;        // 下班時間（週六）
  f90g_16: string;        // 備註
  f90g_17: number;        // 彈性上班時間（分鐘）
  f90g_18: string;        // 午休開始時間
  f90g_19: string;        // 午休停止時間
  f90g_20: number;        // 每日上班時數
  f90g_91: string;        // 建立者
  f90g_92: string | null; // 建立日期
  f90g_93: string;        // 最後修改者
}

export interface ListResponse {
  data: F90G[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  code: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const workScheduleApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/work-schedule', { params });
    return res.data;
  },

  async search(keyword: string, page = 1, size = 100): Promise<ListResponse> {
    const res = await apiClient.get('/api/work-schedule/search', {
      params: { keyword, page, size },
    });
    return res.data;
  },

  async get(code: string): Promise<F90G> {
    const res = await apiClient.get(`/api/work-schedule/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: Partial<F90G>): Promise<F90G> {
    const res = await apiClient.post('/api/work-schedule', data);
    return res.data;
  },

  async update(code: string, data: Partial<F90G>): Promise<F90G> {
    const res = await apiClient.put(`/api/work-schedule/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/work-schedule/${encodeURIComponent(code)}`);
  },
};
